<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  conversation: { type: Object, required: true },
});

const { t } = useI18n();

const hasUnread = computed(() => props.conversation.unread_count > 0);
const isNewConversation = computed(
  () =>
    hasUnread.value &&
    !props.conversation.agent_last_seen_at &&
    !props.conversation.first_reply_created_at
);

const label = computed(() => {
  if (isNewConversation.value)
    return t('UNREAD_MESSAGE_LABEL.NEW_CONVERSATION');
  return hasUnread.value
    ? t('UNREAD_MESSAGE_LABEL.UNREAD')
    : t('UNREAD_MESSAGE_LABEL.READ');
});

const icon = computed(() => {
  if (isNewConversation.value) return 'i-lucide-message-square-plus';
  return hasUnread.value ? 'i-lucide-mail' : 'i-lucide-mail-open';
});
</script>

<template>
  <span
    class="mt-1.5 inline-flex max-w-full w-fit items-center gap-1 rounded py-0.5 text-xs font-medium"
    :class="
      hasUnread
        ? 'bg-n-teal-3 px-1.5 text-n-brand-text'
        : 'px-0 text-n-slate-10'
    "
  >
    <Icon :icon="icon" class="size-3.5 shrink-0" />
    <span class="truncate">{{ label }}</span>
  </span>
</template>
